import Rover from '@rover/globals/Rover';
import $ from '@rover/globals/jquery';
import reportError from '@rover/utilities/reportError';
import _ from '@rover/globals/underscore';
import dataLayer from '@rover/globals/dataLayer';

Rover.utils = Rover.utils || {};

let hasInitialized = false;

function initializeGATrackingEvents() {
  Rover.utils.initGAEvents(document);
}

function init() {
  /**
   * Set up safe to use scroll and resize events
   * @see - http://ejohn.org/blog/learning-from-twitter/
   */
  if (hasInitialized) {
    return;
  }
  hasInitialized = true;
  const $window = $(window);

  // Fire scroll event max once every 150ms
  $window.on(
    'scroll',
    _.throttle(() => {
      $window.trigger('safeScroll');
    }, 75)
  );

  // Fire resize event only after resizing has stopped for 250ms
  $window.on(
    'resize',
    _.debounce(() => {
      $window.trigger('safeResize');
    }, 250)
  );

  initializeGATrackingEvents();
}

function recordClickEventHandler() {
  const eventName = $(this).attr('data-record-click-event');
  if (eventName) {
    dataLayer.push({
      event: 'record-event',
      eventName,
    });
  }
}

Rover.utils.initGAEvents = parentEl => {
  if (_.isUndefined(parentEl) || $(parentEl).length === 0) {
    return;
  }

  const parent = $(parentEl)[0]; // allow both normal and jquery elements

  // search for all data-track-event dom elements and register their events
  const events = parent.querySelectorAll('[data-track-event]');
  [].forEach.call(events, el => {
    const { dataset } = el;

    if (dataset) {
      $(el).on(dataset.eventType, () => {
        let eventMerge = {};
        if (dataset.eventMerge) {
          try {
            eventMerge = JSON.parse(dataset.eventMerge);
          } catch (err) {
            reportError(new Error(`Data Event Merge Error: ${err}`));
          }
        }
        dataLayer.push(_.extend({ event: dataset.event }, eventMerge));
      });
    }
  });
};

export default {
  init,
  recordClickEventHandler,
  initializeGATrackingEvents,
};



// WEBPACK FOOTER //
// ../utilities/events.js